import NNotification from '../NNotification.vue';
import { createComponent } from './element';
import { NotificationOptions } from './types';

const Notification = (options: NotificationOptions) => {
  createComponent(NNotification, options);
};

export default Notification;
